'use strict';

/**
 * Handles special analytics custom events and updates digitalData (aka the
 * "dataLayer" the appropriate values). Please refer to the docs for specifics.
 * TODO: The typing for Dropdowns is currently incorrect. Please pass null until this is resolved.
 * @param eventName - name of event. Should be shared with Marketing
 * @param eventDetail - the relevant info from the event
 * @param targetElement - the element on which the event was triggered. If unavailable,
 * specify as null. This dispatch the event on the Document.
 * @param digitalDataContainerName - name of the container in the digitalData object
 * in general, you shouldn't have too many different names (and always confirm with
 * the marketing team)
 * @returns
 */
var dispatchTrackingEvent = function dispatchTrackingEvent(eventName, eventDetail, targetElement, digitalDataContainerName) {
  // create detail object for CustomEvent func
  var details = {
    detail: {
      eventName: eventDetail.eventName || eventName,
      eventData: eventDetail.eventData,
      srcAction: eventDetail.srcAction || null
    }
  };

  // Appends data to the digital data for Adobe Target's use
  appendDigitalData(details, digitalDataContainerName);

  // creates custom event, with name and details
  var event = new CustomEvent(eventName, details);

  // dispatch the event on the targetElement or the document
  // Marketing specified that we can just use the document to fire events
  // if we'd like
  if (targetElement) {
    targetElement.dispatchEvent(event);
  } else {
    document.dispatchEvent(event);
  }
};

/**
 * Appends object to the digitalData object located in the window
 * @param data
 * @param containerName
 */
var appendDigitalData = function appendDigitalData(data, containerName) {
  // TODO: Get rid of the any here. For some reason, the globals.d.ts.
  // My suspicion is that we need a separate globals.d.ts for react-components.
  // make sure we have a dataLayer array on the window
  if (!window.digitalData) {
    window.digitalData = {};
  }
  // set the specified key to be the relevant information
  window.digitalData[containerName] = data;
};

var PopupTrackingEvents = /*#__PURE__*/function (PopupTrackingEvents) {
  PopupTrackingEvents["POPUP_DISPLAYED"] = "FormRatesTable-Popup-Displayed";
  PopupTrackingEvents["LO_POPUP_DISPLAYED"] = "LoanOfficerRateTablePopup-Displayed";
  PopupTrackingEvents["LO_POPUP_CTA_YES"] = "LoanOfficerRateTablePopup-Button-Yes";
  PopupTrackingEvents["LO_POPUP_CTA_NO"] = "LoanOfficerRateTablePopup-Button-No";
  return PopupTrackingEvents;
}({});
var ToolTipTrackingEvents = /*#__PURE__*/function (ToolTipTrackingEvents) {
  ToolTipTrackingEvents["POINTS"] = "ToolTip-Points";
  ToolTipTrackingEvents["MONTHLY_PAYMENT"] = "ToolTip-MonthlyPayment";
  return ToolTipTrackingEvents;
}({});
var RatesTableFormEvents = /*#__PURE__*/function (RatesTableFormEvents) {
  RatesTableFormEvents["POPUP_BUTTON_CLOSE"] = "FormRatesTable-Popup-Button-close";
  RatesTableFormEvents["POPUP_BUTTON_APPLY_NOW"] = "FormRatesTable-Popup-Button-apply-now";
  RatesTableFormEvents["POPUP_BUTTON_REFINE_SEARCH"] = "FormRatesTable-Popup-Button-refine-search";
  RatesTableFormEvents["POPUP_BUTTON_REDIRECT"] = "FormRatesTable-Popup-Button_redirect";
  RatesTableFormEvents["FORM_SUBMIT"] = "FormRatesTable_Submit";
  RatesTableFormEvents["ADVANCED_OPTIONS_CLICKED"] = "FormRatesTable-Advanced-Option_clicked";
  return RatesTableFormEvents;
}({});
var RateTableFieldInputEvents = /*#__PURE__*/function (RateTableFieldInputEvents) {
  RateTableFieldInputEvents["ZIP_CODE_CLICK"] = "RatesTableForm-Zip-Code-Click";
  RateTableFieldInputEvents["FIRST_NAME_CLICK"] = "RatesTableForm-First-Name-Click";
  RateTableFieldInputEvents["LAST_NAME_CLICK"] = "RatesTableForm-Last-Name-Click";
  RateTableFieldInputEvents["PHONE_NUMBER_CLICK"] = "RatesTableForm-Phone-Click";
  RateTableFieldInputEvents["EMAIL_CLICK"] = "RatesTableForm-Email-Click";
  RateTableFieldInputEvents["PURCHASE_PRICE"] = "RatesTableForm-Purchase-Price-Click";
  RateTableFieldInputEvents["DOWN_PAYMENT"] = "RatesTableForm-Down-Payment-Click";
  RateTableFieldInputEvents["DOWN_PAYMENT_PERCENT"] = "RatesTableForm-Down-Payment-Percent-Click";
  RateTableFieldInputEvents["HOME_VALUE"] = "RatesTableForm-Home-Value-Click";
  RateTableFieldInputEvents["LOAN_BALANCE"] = "RatesTableForm-Loan-Balance-Click";
  return RateTableFieldInputEvents;
}({});
var RateTableFieldDropdownEvents = /*#__PURE__*/function (RateTableFieldDropdownEvents) {
  RateTableFieldDropdownEvents["LOAN_TYPE"] = "RatesTableForm-Loan-Type-Select";
  RateTableFieldDropdownEvents["CREDIT_SCORE"] = "RatesTableForm-Credit-Score-Select";
  RateTableFieldDropdownEvents["PROPERTY_TYPE"] = "RatesTableForm-Property-Type-Select";
  RateTableFieldDropdownEvents["PRIMARY_USE"] = "RatesTableForm-Primary-Use-Select";
  RateTableFieldDropdownEvents["MILITARY"] = "RatesTableForm-Military-Select";
  RateTableFieldDropdownEvents["POINTS"] = "RatesTableForm-Points-Select";
  return RateTableFieldDropdownEvents;
}({});

exports.PopupTrackingEvents = PopupTrackingEvents;
exports.RateTableFieldDropdownEvents = RateTableFieldDropdownEvents;
exports.RateTableFieldInputEvents = RateTableFieldInputEvents;
exports.RatesTableFormEvents = RatesTableFormEvents;
exports.ToolTipTrackingEvents = ToolTipTrackingEvents;
exports.dispatchTrackingEvent = dispatchTrackingEvent;
